import { createSlice } from "@reduxjs/toolkit";

interface ViewState {
  viewId: {
    selectedViewId: number | null;
    defaultViewId: number | null;
  };
  applyWithoutSave: boolean;
}

const initialState: ViewState = {
  viewId: {
    selectedViewId: null,
    defaultViewId: null,
  },
  applyWithoutSave: false,
};

const viewIdSlice = createSlice({
  name: "viewIdDetailsHatv",
  initialState,
  reducers: {
    updateViewHatvId: (state, action) => {
      state.viewId = { ...action.payload.viewIdDetailsHatv };

      state.applyWithoutSave = action.payload.applyWithoutSave ?? false;
    },
  },
});

export const { updateViewHatvId } = viewIdSlice.actions;
export default viewIdSlice.reducer;
